import {
  PopularVisibleLanguagesList,
  TextToSpeechAvailableForLanguages
} from "../../constants";

const voiceSupportedLanguages = TextToSpeechAvailableForLanguages.join();
const popularVisibleLanguages = PopularVisibleLanguagesList.join(",");

export const getUserPreferredLanguageCode = () => {
  let langCode = new URLSearchParams(window.location.search).get("lang");

  return langCode;
};

export const initGoogleTranslateElement = (
  showAllLanguages,
  defaultLangCode = "en",
  layout = window.google.translate.TranslateElement.InlineLayout.SIMPLE,
  isFromFindDentist = false
) => {
  const currentLangCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("googtrans="));

  if (isFromFindDentist && (!currentLangCookie || currentLangCookie.endsWith("/en"))) {
    const cookieValue = "/en/en";
    const hostname = window.location.hostname;
    const expiry = "expires=Thu, 01 Jan 1970 00:00:00 UTC";

    const hostParts = hostname.split(".");
    const domains = ["", hostname, `.${hostname}`];
    if (hostParts.length > 2) {
      const rootDomain = hostParts.slice(-2).join(".");
      domains.push(rootDomain, `.${rootDomain}`);
    }

    domains.forEach(domain => {
      const domainPart = domain ? `; domain=${domain}` : "";
      document.cookie = `googtrans=; ${expiry}${domainPart}; path=/`;
    });

    document.cookie = `googtrans=${cookieValue}; path=/`;
    document.cookie = `googtrans=${cookieValue}; domain=${hostname}; path=/`;
    document.cookie = `googtrans=${cookieValue}; domain=.${hostname}; path=/`;
  }

  const options = {
    pageLanguage: "en",
    includedLanguages: showAllLanguages ? popularVisibleLanguages : voiceSupportedLanguages,
    autoDisplay: false,
    multilanguagePage: true
  };

  if (layout) options.layout = layout;
  new window.google.translate.TranslateElement(options, "google_translate_element");
};

export const handleTranslateClick = (event) => {
  if (
    event?.target?.id === "google_translate_element" ||
    event?.target?.closest("#google_translate_element")
  ) {
    event.preventDefault();
  }
};

function changeGoogleStyles() {
  let iframeElement = $("iframe");
  let iframeBody = iframeElement?.contents().find("body");
  let container = iframeElement?.contents().find(".VIpgJd-ZVi9od-vH1Gmf");
  if (iframeElement.length && iframeBody.length && container.length) {
    let margin = 2;
    let width = $(window).width() - 10;
    container.css({
      overflow: "scroll",
      height: "290px",
      width: width + "px"
    });

    if (width <= 768) {
      container.css({
        overflow: "scroll",
        height: "290px",
        width: width + "px"
      });
    } else {
      container.css({
        overflow: "scroll",
        height: "270px",
        width: width + "px"
      });
    }

    iframeBody.css({ overflow: "none" });
    iframeElement.css({ left: margin + "px" });
  }
  if ($(".goog-te-menu-frame").contents().find("body").length) {
    $(".goog-te-menu-frame").contents().find("body").css({
      "overflow-x": "auto",
      "box-sizing": "border-box"
    });
  } else {
    setTimeout(changeGoogleStyles, 500);
  }
}

export const handleGoogleTranslatorOnPageLoad = (
  showAllLanguages = true,
  defaultLangCode = "en",
  isFromFindDentist = false
) => {
  const currentLang = getTranslatedLanguageCode();

  if (isFromFindDentist && currentLang === 'en') {
    const cookieValue = "/en/en";
    const hostname = window.location.hostname;
    document.cookie = `googtrans=${cookieValue}; path=/`;
    document.cookie = `googtrans=${cookieValue}; domain=${hostname}; path=/`;
    document.cookie = `googtrans=${cookieValue}; domain=.${hostname}; path=/`;
  }

  if (!document.getElementById("google-translate-script")) {
    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);
  }

  window.googleTranslateElementInit = () => {
    const layout = isFromFindDentist
      ? null
      : window.google.translate.TranslateElement.InlineLayout.SIMPLE;

    initGoogleTranslateElement(showAllLanguages, defaultLangCode, layout);

    if (!isFromFindDentist && showAllLanguages) {
      changeGoogleStyles();
    }
  };

  handleTranslateClick();
  document.addEventListener("click", handleTranslateClick);
};

export const getTranslatedLanguageCode = () => {
  const cookieValue = `; ${document.cookie}`;
  const parts = cookieValue.split(`; googtrans=`);

  if (parts.length >= 2) {
    const googtransValue = parts[1].split(";").shift();
    const targetLang = googtransValue.split("/")[2];

    return targetLang || null;
  }

  return 'en';
};
